import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CountrySelectorComponent} from './country-selector.component';
import {ComboBoxDropdownModule, NgDesignSystemModule} from 'ng-design-system';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ConfigModule, I18nModule} from '@spartacus/core';
import {CountrySwitchModalModule} from './country-switch-modal/country-switch-modal.module';
import {CountrySelectorService} from '@app/services/country-selector.service';
import {A11yModule} from '@angular/cdk/a11y';
import {GeolocationService} from '@app/services/geolocation.service';

@NgModule({
  declarations: [
    CountrySelectorComponent,
  ],
  imports: [
    CommonModule,
    ComboBoxDropdownModule,
    NgbModule,
    I18nModule,
    NgDesignSystemModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CountrySelector: {
          component: CountrySelectorComponent
        }
      }
    }),
    CountrySwitchModalModule,
    A11yModule,
  ],
  providers: [
    CountrySelectorService,
    GeolocationService,
  ],
  exports: [
    CountrySelectorComponent,
  ]
})
export class CountrySelectorModule {
}
